import React from 'react'; 
import Pic from "./DragIcons.png"
const customeIcons=(props:any) => 
{
    return <>{props.value} <img style={{float:"right",
    marginTop:"10px"}}
    src={Pic}/> </>
};

export default customeIcons;